import { NgModule } from '@angular/core';
import { VacanciesComponent } from './pages/vacancies/vacancies.component';
import { CommonModule } from '@angular/common';
import { CommonModule as SharedModule } from '../common/common.module';
import { VacanciesTableComponent } from './components/vacancies-table/vacancies-table.component';
import { DashboardCommonModule } from '../dashboardCommon/dashboardCommon.module';

@NgModule({
  declarations: [
    VacanciesComponent,
    VacanciesTableComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DashboardCommonModule,
  ]
})
export class VacanciesModule { }
